import { ShieldAlert } from 'lucide-react'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { MAIN_ID } from '~/components/SkipLink'
import { Button } from '~/components/ui/button'
import { useBranding } from '~/helpers/branding/branding-context'
import { pageTitle } from '~/routes/route-handle'

function Error() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { appName } = useBranding()
  // Écran d'erreur du routeur : il remplace `Root`, donc `RouteAnnouncer` ;
  // sans ça l'onglet garderait le titre de l'écran qui a planté.
  useEffect(() => {
    document.title = pageTitle(t('pageTitle.error'), appName)
  }, [t, appName])

  return (
    <main id={MAIN_ID} className="w-full h-dvh bg-background flex flex-col justify-center items-center gap-6">
      <ShieldAlert width={48} height={48} />
      <h1 className="font-bold font-primary text-foreground">
        {t('an.error.occurred')}
      </h1>
      <Button className="rounded-lg px-4 py-2" type="button" onClick={() => navigate('/')}>
        {t('common.back')}
      </Button>
    </main>
  )
}

export default Error
